module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/og_page1.36298805.jpg";